<template>
  <div class="complete">
    <h1 class="complete__heading">組み合わせ結果</h1>

    <v-complete-error @error="errorHandler($event)"/>

    <v-complete-cart/>

    <v-complete-nameplate v-model="nameplate" v-if="showNameplate"/>

    <div class="complete__action">
      <button
        class="complete__select"
        @click="selectHandler()">
        組み合わせを変更する
      </button>

      <button
        class="complete__cart complete__cart--loading"
        v-if="!authority || error.soldout === null"
        @click="addCart()"
        disabled>
        <i class="fas fa-spinner fa-spin"></i>
      </button>

      <template v-if="authority && error.soldout || authority && error.soldout === false">
        <button
          class="complete__cart"
          v-if="error.soldout"
          disabled>
          売り切れ商品が含まれています
        </button>
        <button
          class="complete__cart"
          v-if="!nameplate.name || !nameplate.birthday || !nameplate.type"
          disabled>
          名前札を入力してください
        </button>
        <button
          class="complete__cart"
          v-else-if="authority === 'admin' || authority === 'guest'"
          @click="addCart()"
          :disabled="cart.state === 'loading'">
          ご購入手続き
        </button>

        <div v-if="authority === 'admin'" class="complete__register">
          <button
            class="complete__register-button"
            @click="addRegister()"
            :disabled="register.state === 'loading'">
            組み合わせ商品を登録する
          </button>
        </div>
      </template>
      <button class="complete__favorite-view" @click="viewFavorite()">
        <span class="complete__favorite-view__inner">お気に入り一覧を見る</span>
      </button>

      <el-popover
        class="complete__favorite-outer"
        v-model="favorite.tooltip"
        placement="top"
        width="224"
        content="お気に入りに追加しました"
        popper-class="complete__favorite-popover">
        <button
          class="complete__favorite"
          @click="addFavorite()"
          :disabled="favorite.state === 'loading' || favorite.state === 'disabled'"
          slot="reference">
          <i class="fas fa-star"></i>
          <span class="complete__favorite__inner">お気に入りに追加</span>
        </button>
      </el-popover>
    </div>

    <v-complete-item-select v-model="select.state"/>
  </div>
</template>



<script>
import { mapState } from 'vuex'
import {
  Popover,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/popover.css'

export default {
  components: {
    'el-popover': Popover,
    'v-complete-nameplate': require('@/components/complete-nameplate.vue').default,
    'v-complete-cart': require('@/components/complete-cart.vue').default,
    'v-complete-error': require('@/components/complete-error.vue').default,
    'v-complete-item-select': require('@/components/complete-item-select.vue').default,
  },
  computed: {
    ...mapState({
      stateCartItems: state => state.cart.items,
      stateCanvastImg: state => state.canvas.img,
      authority: state => state.page.authority,
      items: state => state.cart.items,
      showNameplate: state => state.step.showNameplate,
    }),
    quantity () {
      let num = 0
      for(let key in this.stateCartItems) {
        if (this.stateCartItems[key].price) {
          num = num + 1
        }
      }
      return num
    },
  },
  data() {
    return {
      select: {
        state: false,
      },
      favorite: {
        state: false,
        tooltip: false,
      },
      cart: {
        state: false,
      },
      register: {
        state: false,
      },
      error: {
        soldout: null,
      },
      nameplate: {
        name: '',
        birthday: '',
        type: null,
        hangingDoll: null,
        nameFlags: [],
        hangingDolls: [],
      }
    }
  },
  created() {
    this.loginCheck()
    this.refreshNameFlag()
    this.refreshHangingDolls()
  },
  methods: {
    refreshNameFlag() {
      let apiURL
      if (this.config.debug) {
        apiURL = '/index_dev.php/api/choice/flags'
      } else {
        apiURL = '/api/choice/flags'
      }

      if (this.$route.path.match(/gogatsu/)) {
        apiURL += '?type=2'
      } else {
        apiURL += '?type=1'
      }

      axios.get(apiURL, {
        params: this.$route.query
      })
      .then(response => {
        console.log('flags response')
        console.log(response.data)
        this.nameplate.nameFlags = response.data
      })
      .catch((error) => {
        console.log(error)
      })
    },
    refreshHangingDolls() {
      let apiURL
      if (this.config.debug) {
        apiURL = '/index_dev.php/api/choice/hangingDolls'
      } else {
        apiURL = '/api/choice/hangingDolls'
      }

      if (this.$route.path.match(/gogatsu/)) {
        apiURL += '?type=2'
      } else {
        apiURL += '?type=1'
      }

      axios.get(apiURL, {
        params: this.$route.query
      })
      .then(response => {
        console.log('hangingDolls response')
        console.log(response.data)
        this.nameplate.hangingDolls = response.data
      })
      .catch((error) => {
        console.log(error)
      })
    },
    loginCheck() {
      let apiURL

      if (this.config.debug) {
        apiURL = '/index_dev.php/api'
      } else {
        apiURL = '/api'
      }

      axios.get(apiURL + '/check_login/admin')
        .then(response => {
          if (response.data.login) {
            this.$store.commit('page/authoritySet', 'admin')
          } else {
            this.$store.commit('page/authoritySet', 'guest')
          }
        })
    },
    selectHandler() {
      this.$set(this.select, 'state', true)
    },
    addFavorite() {
      let apiURL
      this.$set(this.favorite, 'state', 'loading')

      if (this.config.debug) {
        apiURL = '/index_dev.php/api/choice'
      } else {
        apiURL = '/api/choice'
      }


      axios.post(apiURL + '/favorite', {
          params: this.$route.query,
          nameplate: this.nameplate,
          img: this.stateCanvastImg,
        })
        .then(response => {
          console.log('response')
          console.log(response.data)

          this.$set(this.favorite, 'state', 'disabled')
          this.$set(this.favorite, 'tooltip', true)
          setTimeout(() => {
            this.$set(this.favorite, 'tooltip', false)
          }, 1000)
        })
        .catch((error) => {
          this.$set(this.favorite, 'state', false)
        })
    },
    viewFavorite() {
      let routeData = this.$router.resolve('/custom/favorite')
      window.open(routeData.href, '_blank');
    },
    addCart() {
      let apiURL
      this.$set(this.cart, 'state', 'loading')

      if (this.config.debug) {
        apiURL = '/index_dev.php/api/choice'
      } else {
        apiURL = '/api/choice'
      }

      axios.post(apiURL + '/cart', {
          params: this.$route.query,
          nameplate: this.nameplate,
          img: this.stateCanvastImg,
        })
        .then(response => {
          console.log('response')
          console.log(response.data)

          if (this.authority !== 'admin') {
            this.$ga.event({
              eventCategory: 'choice',
              eventAction: 'action',
              eventLabel: 'ecommerce',
              eventValue: 1
            })
          }

          location.href = response.data.redirect
        })
        .catch((error) => {
          this.$set(this.cart, 'state', false)
          if(error.response.data.error === "在庫がありません") this.soldoutError(error.response.data.selectedItems)
        })
    },
    addRegister() {
      let apiURL
      this.$set(this.register, 'state', 'loading')

      if (this.config.debug) {
        apiURL = '/index_dev.php/api/choice'
      } else {
        apiURL = '/api/choice'
      }

      axios.post(apiURL + '/register', {
          params: this.$route.query,
          nameplate: this.nameplate,
          img: this.stateCanvastImg,
        })
        .then(response => {
          location.href = response.data.redirect

          console.log('response')
          console.log(response.data)
        })
        .catch((error) => {
          this.$set(this.register, 'state', false)
        })
    },
    errorHandler(event) {
      this.$set(this.error, 'soldout', event)
    },
    soldoutError(data) {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
  }
}
</script>



<style lang="scss">
.complete {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 160px 20px 144px;
  @include breakpoints-min(md) {
    padding-top: 272px;
  }
  @include breakpoints-min(lg) {
    width: 512px;
    margin-left: #{($col-width * 2 - 448) / 2};
    margin-right: #{($col-width * 2 - 448) / 2};
    padding: 0 0 144px;
  }
  &__heading {
    position: relative;
    font-family: $serif;
    font-size: 24px;
    font-weight: normal;
    margin-top: 48px;
    margin-bottom: 48px;
    padding-left: 36px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: url(/choice/img/icon/mark.svg) center center / 18px 18px no-repeat;
      width: 18px;
      height: 18px;
    }
  }
  &__action {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 24px;
  }
  &__register {
    width: 100%;
    margin-top: 12px;
  }
  &__select,
  &__cart,
  &__favorite,
  &__favorite-view,
  &__register-button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: $transition;
    appearance: none;
    outline: none;
    border-radius: 4px;
    border: none;
    font-size: 13px;
    line-height: 1;
    width: calc(50% - 8px);
    padding-top: 20px;
    padding-bottom: 20px;
    &:disabled {
      cursor: no-drop;
    }
  }
  &__select {
    border: 1px solid $accent-color;
    background-color: #fff;
    color: $accent-color;
    @include hover() {
      background-color: $accent-color-bg;
    }
    @include active() {
      border-color: $accent-color-active;
      color: $accent-color-active;
    }
  }
  &__cart {
    background-color: $accent-color;
    color: #fff;
    @include hover() {
      background-color: $accent-color-hover;
    }
    @include active() {
      background-color: $accent-color-active;
    }
    &:disabled {
      opacity: 0.6;
      background-color: $accent-color !important;
    }
    &--loading {
      &:disabled {
        opacity: 1;
      }
    }
  }
  .complete-nameplate {
    margin-top: 32px;
  }
  &__register-button {
    background-color: $accent-color;
    color: #fff;
    width: 100%;
    @include hover() {
      background-color: $accent-color-hover;
    }
    @include active() {
      background-color: $accent-color-active;
    }
    &:disabled {
      opacity: 0.6;
      background-color: $accent-color !important;
    }
  }
  &__favorite-outer {
    display: block;
    width: calc(50% - 8px);
  }
  &__favorite {
    border: 1px solid $oc-gray-4;
    background-color: transparent;
    width: 100%;
    margin-top: 16px;
    @include hover() {
      border: 1px solid $oc-yellow-6;
    }
    @include active() {
      border: 1px solid $oc-yellow-6;
      background-color: $oc-yellow-0;
    }
    &:disabled {
      border-color: $oc-gray-1 !important;
      background-color: $oc-gray-1 !important;
      .fas {
        opacity: 0.6;
      }
    }
    .fas {
      transition: $transition;
      text-decoration: none;
      color: $oc-yellow-6;
      margin-right: 8px;
    }
  }
  &__favorite-popover {
    font-size: 13px;
    text-align: center;
  }
  &__favorite-view {
    background-color: transparent;
    margin-top: 16px;
    @include hover() {
      background-color: transparent;
      text-decoration: underline;
    }
    @include active() {
      background-color: $oc-gray-1;
      text-decoration: underline;
    }
  }

  .complete-error {
    margin-bottom: 32px;
  }
}

.app-gogatsu {
    .complete {
        &__heading {
            &::before {
                background: url(/choice/img/icon/mark-gogatsu.svg) center center / 18px 18px no-repeat;
            }
        }
        &__select {
            border: 1px solid $gogatsu-accent-color;
            background-color: #fff;
            color: $gogatsu-accent-color;
            @include hover() {
                background-color: $gogatsu-accent-color-bg;
            }
            @include active() {
                border-color: $gogatsu-accent-color-active;
                color: $gogatsu-accent-color-active;
            }
        }
        &__cart {
            background-color: $gogatsu-accent-color;
            color: #fff;
            @include hover() {
                background-color: $gogatsu-accent-color-hover;
            }
            @include active() {
                background-color: $gogatsu-accent-color-active;
            }
            &:disabled {
                opacity: 0.6;
                background-color: $gogatsu-accent-color !important;
            }
            &--loading {
                &:disabled {
                    opacity: 1;
                }
            }
        }
        &__register-button {
            background-color: $gogatsu-accent-color;
            color: #fff;
            @include hover() {
                background-color: $gogatsu-accent-color-hover;
            }
            @include active() {
                background-color: $gogatsu-accent-color-active;
            }
            &:disabled {
                opacity: 0.6;
                background-color: $gogatsu-accent-color !important;
            }
        }
    }
}
</style>
